import React, { useState, useEffect } from 'react';
import { Button, Dropdown, Menu } from 'antd';
import { Link } from "react-router-dom";
import Axios from 'axios';
import { Host } from '../App';
import { UserOutlined, LogoutOutlined } from '@ant-design/icons';
import LineGraph from './LineGraph';
import './Dashboardnew.css';

const NewDashboard = () => {
  // State management
  const [user] = useState(window.localStorage.getItem("Name")?.replace(/[{""}]/g, "") || "User");
  const [date] = useState(new Date());
  const [dailyData, setDailyData] = useState([]);
  const [dailyDataSection, setDailyDataSection] = useState(false);
  const [lastWeekNonUs, setLastWeekNonUs] = useState(0);
  const [lastWeekUs, setLastWeekUs] = useState(0);
  const [nextWeekNonUs, setNextWeekNonUs] = useState(0);
  const [nextWeekUs, setNextWeekUs] = useState(0);
  const [showLineGraph, setShowLineGraph] = useState(false);
  const [rank] = useState(window.localStorage.getItem("Rank") === '"Admin"');
  const token = window.localStorage.getItem("acessToken");

  // Fetch dashboard data
  useEffect(() => {
    const fetchDashboardData = async () => {
      try {
        const queryParams = {
          start_date: date.toISOString().slice(0, 10),
          token: token
        };

        // Fetch today's shipment data
        const todayResponse = await Axios.get(`https://${Host}/ship_Today`, { params: queryParams });
        if (todayResponse.data.length > 0) {
          setDailyData(todayResponse.data);
          setDailyDataSection(true);
        }

        // Fetch weekly data in parallel
        const endpoints = [
          { url: 'shipped_lastweek_nonUs', setter: setLastWeekNonUs },
          { url: 'shipped_lastweek_Us', setter: setLastWeekUs },
          { url: 'ship_nextweek_nonUs', setter: setNextWeekNonUs },
          { url: 'ship_nextweek_Us', setter: setNextWeekUs }
        ];

        const promises = endpoints.map(endpoint =>
          Axios.get(`https://${Host}/${endpoint.url}`, { params: queryParams })
            .then(data => {
              if (data.data.length > 0) {
                endpoint.setter(data.data[0].QTY);
              }
            })
        );

        await Promise.all(promises);
      } catch (error) {
        console.error('Error fetching dashboard data:', error);
      }
    };

    fetchDashboardData();
  }, [date, token]);

  const handleLogout = () => {
    window.localStorage.clear();
    sessionStorage.clear();
    Axios.get(`https://${Host}/logout`);
    window.location.href = '/';
  };

  const userMenu = (
    <Menu>
      <Menu.Item key="logout" icon={<LogoutOutlined />}>
        <a onClick={handleLogout} href="/">Logout</a>
      </Menu.Item>
    </Menu>
  );

  const dashboardLinks = [
    { to: "/adddata", label: "PO DATA" },
    { to: "/reaminedparts", label: "OPEN ORDERS" },
    { to: "/pivot", label: "PIVOT" },
    { to: "/attendance", label: "ATTENDANCE" },
    { to: "/Production", label: "PRODUCTION" },
    { to: "/Maintenance", label: "MAINTENANCE" },
    { to: "/PurchaseRequest", label: "PURCHASE REQUEST" },
    { to: "/Scheduling", label: "SCHEDULING" },
  ];

  return (
    <div className="dashboard-container">
      {/* Top Bar */}
      <header className="dashboard-header">
        <div className="dashboard-title">
          <h1>Production Dashboard</h1>
        </div>

      </header>

      <div className="dashboard-content">
        {/* Sidebar Navigation */}
        <aside className="dashboard-sidebar">
          <nav className="sidebar-nav">
            {dashboardLinks.map((link, index) => (
              <Link to={link.to} key={index} className="nav-link">
                <Button type="primary" block className="nav-btn">
                  {link.label}
                </Button>
              </Link>
            ))}
            {rank && (
              <Link to="/supplychain" className="nav-link">
                <Button type="primary" block className="nav-btn">
                  SUPPLY CHAIN
                </Button>
              </Link>
            )}
            <Button
              type="primary"
              block
              className="nav-btn"
              onClick={() => setShowLineGraph(!showLineGraph)}
            >
              {showLineGraph ? 'SHOW SHIPMENTS' : 'DAILY DATA RECORD'}
            </Button>
            <Button
              type="primary"
              block
              className="nav-btn logout-btn"
              onClick={handleLogout}
            >
              LOGOUT
            </Button>
          </nav>
        </aside>

        {/* Main Content Area */}
        <main className="dashboard-main">
          {showLineGraph ? (
            <LineGraph />
          ) : (
            <div className="shipments-section">
              <h2 className="section-title">TODAY'S SHIPMENT CONSIGNEES</h2>
              <div className="shipments-grid">
                {dailyDataSection ? (
                  dailyData.map((item, index) => (
                    <Link
                      to="/pivot"
                      key={index}
                      className="shipment-card-link"
                    >
                      <div className="shipment-card">
                        <div className="customer-name">{item.CUSTOMER}</div>
                        <div className="parts-count">{item.Remained_parts} parts</div>
                      </div>
                    </Link>
                  ))
                ) : (
                  <div className="no-shipments">
                    <h3>NOTHING TO SHIP TODAY</h3>
                  </div>
                )}
              </div>
            </div>
          )}

          {/* Weekly Stats */}
          <div className="stats-section">
            <h2 className="section-title">WEEKLY SHIPMENT OVERVIEW</h2>
            <div className="stats-grid">
              <div className="stat-card">
                <h3>Current Week (NON-US)</h3>
                <div className="stat-value">{nextWeekNonUs}</div>
                <p>Parts to ship</p>
              </div>
              <div className="stat-card">
                <h3>Last Week (NON-US)</h3>
                <div className="stat-value">{lastWeekNonUs}</div>
                <p>Parts shipped</p>
              </div>
              <div className="stat-card">
                <h3>Current Week (US)</h3>
                <div className="stat-value">{nextWeekUs}</div>
                <p>Parts to ship</p>
              </div>
              <div className="stat-card">
                <h3>Last Week (US)</h3>
                <div className="stat-value">{lastWeekUs}</div>
                <p>Parts shipped</p>
              </div>
            </div>
          </div>
        </main>

        {/* Announcements Sidebar */}
        <aside className="announcements-sidebar">
          <div className="announcements-container">
            <h2 className="section-title">ANNOUNCEMENTS</h2>
            <Announcements />
          </div>
        </aside>
      </div>
    </div>
  );
};

// Announcements Component
const Announcements = () => {
  const [announcements, setAnnouncements] = useState([]);
  const [newMessage, setNewMessage] = useState('');
  const [department, setDepartment] = useState('');
  const [type, setType] = useState('');
  const user = window.localStorage.getItem("Name")?.replace(/[{""}]/g, "") || "User";
  const token = window.localStorage.getItem("acessToken");

  useEffect(() => {
    fetchAnnouncements();
  }, []);

  const fetchAnnouncements = async () => {
    try {
      const response = await Axios.get(`https://${Host}/getNews`, {
        params: {
          start_date: new Date().toISOString().slice(0, 10),
          token: token
        }
      });
      setAnnouncements(response.data);
    } catch (error) {
      console.error('Error fetching announcements:', error);
    }
  };

  const handlePublish = async () => {
    if (!newMessage.trim() || !department || !type) return;

    try {
      await Axios.post(`https://${Host}/addNews`, {
        User: user,
        Date: new Date().toISOString().slice(0, 10),
        Message: newMessage,
        Department: department,
        Type: type
      });
      setNewMessage('');
      setDepartment('');
      setType('');
      fetchAnnouncements();
    } catch (error) {
      console.error('Error publishing announcement:', error);
    }
  };

  const departments = [
    'PRODUCTION', 'MAINTENANCE', 'MANAGEMENT', 'WOODSHOP',
    'UPHOLSTERY', 'LOGISTICS', 'GENERAL', 'OTHER'
  ];

  const types = [
    'High Important', 'Low Important', 'Warning', 'Urgent', 'Informative'
  ];

  return (
    <div className="announcements-wrapper">
      <div className="announcements-list">
        {announcements.length > 0 ? (
          announcements.map((news) => (
            <div key={news.ID} className="announcement-item">
              <div className="announcement-message">{news.Message}</div>
              <div className="announcement-meta">
                <span className="announcement-type">{news.Type}</span>
                <span className="announcement-department">{news.Department}</span>
                <span className="announcement-user">{news.User}</span>
                <span className="announcement-date">
                  {new Date(news.Date).toLocaleDateString()}
                </span>
              </div>
            </div>
          ))
        ) : (
          <p className="no-announcements">No announcements available</p>
        )}
      </div>

      <div className="announcement-form">
        <h3>New Announcement</h3>
        <textarea
          className="announcement-textarea"
          placeholder="Write your announcement here..."
          value={newMessage}
          onChange={(e) => setNewMessage(e.target.value)}
          rows="3"
        />

        <div className="form-controls">
          <select
            className="form-select"
            value={department}
            onChange={(e) => setDepartment(e.target.value)}
          >
            <option value="">Select Department</option>
            {departments.map((dept, index) => (
              <option key={index} value={dept}>{dept}</option>
            ))}
          </select>

          <select
            className="form-select"
            value={type}
            onChange={(e) => setType(e.target.value)}
          >
            <option value="">Select Type</option>
            {types.map((type, index) => (
              <option key={index} value={type}>{type}</option>
            ))}
          </select>
        </div>

        <Button
          type="primary"
          onClick={handlePublish}
          className="publish-btn"
          disabled={!newMessage.trim() || !department || !type}
        >
          Publish Announcement
        </Button>
      </div>
    </div>
  );
};

export default NewDashboard;

